
chart(
  :type="type",
  :params="chartParams",
  :options="options",
  :benchmarkOptions="options",
  :benchmarkOpen="benchmarkOpen",
  :benchmarkEnabled="benchmarkEnabled",
  :public="public",
  :height="650"
)
  span(slot="extra-buttons", v-if="!public")
    b-form-select.btn-xs(
      v-model="aggregation",
      :options="aggregations",
      name="aggregation",
      size="sm"
    )
